import { message } from "antd"
import { axios } from "../../../constants/axiosConfig"
import { SET_OPEN_MODAL_PLANILHA_DIESEL, SET_OPEN_MODAL_PLANILHA_IR_PENSAO_ALIMENTICIA } from "../actionTypes"

export const setOpenModalPlanilhaDiesel = (open = false) => {
    return {
        type: SET_OPEN_MODAL_PLANILHA_DIESEL,
        payload: open
    }
}

export const setOpenModalPlanilhaIrPensaoAlimenticia = (open = false) => {
    return {
        type: SET_OPEN_MODAL_PLANILHA_IR_PENSAO_ALIMENTICIA,
        payload: open
    }
}

export const downloadPlanilhaDiesel = async () => {
    try {
        const response = await axios.get(`planilhas/planilhaDiesel`, {
            responseType: "blob",
        });

        if (response.data) {
            const data = response.data;

            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `planilha-pis-cofins-diesel.rar`);
            document.body.appendChild(link);
            link.click();

            message.success("Download realizado com sucesso")
        }else {
            message.error("Ocorreu um erro ao baixar a planilha")
        }
    } catch (e) {
        console.log(e)
        message.error("Ocorreu um erro ao baixar a planilha")
    }
}

export const downloadPlanilhaIrPensaoAlimenticia = async () => {
    try {
        const response = await axios.get(`planilhas/planilhaIrPensaoAlimenticia`, {
            responseType: "blob",
        });

        if (response.data) {
            const data = response.data;

            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `planilha-ir-pensao-alimenticia.rar`);
            document.body.appendChild(link);
            link.click();

            message.success("Download realizado com sucesso")
        }else {
            message.error("Ocorreu um erro ao baixar a planilha")
        }
    } catch (e) {
        console.log(e)
        message.error("Ocorreu um erro ao baixar a planilha")
    }
}